import { createJSONStorage, persist } from "zustand/middleware";

import { create } from "zustand";

export const useInterswitchDataStore = create(
  persist(
    (set) => ({
      interswitchBillers: [],
      setInterswitchBillers: (billersArray) => set(() => ({ interswitchBillers: billersArray })),
      errorMessage: null,
      setErrorMessage: (message)=> set(()=>({errorMessage : message}))
    }),
    {
      name: "interswitch-data",
      storage: createJSONStorage(() => localStorage),
    }
  )
);

export function getInterswitchBillers(){
   return useInterswitchDataStore.getState().interswitchBillers;
}
export function getInterswitchErrorMessage(){
   return useInterswitchDataStore.getState().errorMessage;
}
export function setInterswitchErrorMessage(message){
   return useInterswitchDataStore.getState().setErrorMessage(message);
}
export function setInterswitchBillers(billers){
   return useInterswitchDataStore.getState().setInterswitchBillers(billers);
}
